import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { TRAININGS_BACKEND_URLS } from 'src/main';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent {
  // Icons
  faArrowLeft = faArrowLeft;

  // Authentication status
  public isAuthenticated$: Observable<boolean>;

  platformName: string;
  patientName: string;

  language: 'de' | 'en';

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private store: Store<{ isAuthenticated: boolean }>,
    private activatedRoute: ActivatedRoute,
  ) {
    this.isAuthenticated$ = this.store.select('isAuthenticated');
    const isNotTrainingsPlatform = TRAININGS_BACKEND_URLS.every(
      (url) => !environment.backendURL.includes(url),
    );
    if (isNotTrainingsPlatform) {
      this.platformName = 'Plattformen eSano Research eCoach und eSano Research online-trainings (eSano Research App und Research Patient:innen Plattform)';
      this.patientName = 'Plattform eSano Research online-trainings (eSano Research App und Research Patient:innen Plattform)';
    } else {
      this.platformName = 'Plattformen eSano eCoach und eSano online-trainings (Patient:innen Plattform)';
      this.patientName = 'Plattform eSano online-trainings (Patient:innen Plattform)';
    }
    const storedLanguage = localStorage.getItem('language');
    this.language = storedLanguage === 'de' ? 'de' : 'en';
    localStorage.setItem('language', this.language);
    this.translateService.use(this.language);
    this.activatedRoute.queryParams.subscribe(
      (params) => this.changeLanguage(params.locale),
    );
  }

  private changeLanguage(paramLanguage: string) {
    if (!paramLanguage || paramLanguage === this.language) {
      return;
    }
    const languages = ['ca', 'de', 'en', 'es', 'fr', 'ro'];
    if (languages.includes(paramLanguage)) {
      this.language = paramLanguage === 'de' ? 'de' : 'en';
      localStorage.setItem('language', this.language);
      this.translateService.use(this.language);
    }
  }

  public redirectToLogin(): void {
    this.router.navigate(['/login']);
  }
}
